export enum ContractActions {
  CREATE_CONTRACT = 'contract/CREATE_CONTRACT',
  EDIT_CONTRACT = 'contract/EDIT_CONTRACT',
  GET_CONTRACT_LIST = 'contract/GET_CONTRACT_LIST',
  SET_CONTRACT_LIST = 'contract/SET_CONTRACT_LIST',
  SET_CONTRACT_ERROR_MESSAGE = 'contract/SET_CONTRACT_ERROR_MESSAGE',
  SET_CONTRACT_SUCCESS_MESSAGE = 'contract/SET_CONTRACT_SUCCESS_MESSAGE',
  REDIRECT_TO_CHECKOUT = 'contract/REDIRECT_TO_SUBSCRIPTION_CHECKOUT',
}
